import React, { useState, useContext } from "react";
import "./BuildDreamInterior.css";
import { LanguageContext } from "../../context/LanguageContext";

import InteriorCottonBeige from "../../assets/images/buildDream/cotonInter.webp";
import InteriorCamelBrown from "../../assets/images/buildDream/camelInter.webp";

import ThumbCottonBeige from "../../assets/images/buildDream/cotonColor.webp";
import ThumbCamelBrown from "../../assets/images/buildDream/camelColor.webp";

const INTERIORS = [
  {
    id: 1,
    name: "Cotton Beige",
    carImg: InteriorCottonBeige,
    thumb: ThumbCottonBeige,
  },
  {
    id: 2,
    name: "Camel Brown",
    carImg: InteriorCamelBrown,
    thumb: ThumbCamelBrown,
  },
];

const BuildDreamInterior = ({ onSelect }) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.buildDream || {};
  const interiorLabels = t.interiors || {};

  const [selected, setSelected] = useState(INTERIORS[0]);

  const handleSelect = (i) => {
    setSelected(i);
    onSelect && onSelect(i);
  };

  return (
    <div className="dream-interior">
      <h4 className="dream-interior-title">{t.chooseInterior}</h4>

      <div className="dream-interior-main">
        <div className="dream-interior-display">
          <img
            src={selected.carImg}
            alt={interiorLabels[selected.name] || selected.name}
            className="dream-interior-img"
          />
        </div>

        <div className="dream-interior-list">
          {INTERIORS.map((i) => (
            <div
              key={i.id}
              className={`dream-interior-item ${
                selected.id === i.id ? "active" : ""
              }`}
              onClick={() => handleSelect(i)}
            >
              <div className="dream-interior-thumb-wrapper">
                <img
                  src={i.thumb}
                  alt={interiorLabels[i.name] || i.name}
                  className="dream-interior-thumb"
                />
              </div>
              <p className="dream-interior-name">
                {interiorLabels[i.name] || i.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuildDreamInterior;
